#import "../../../../../../common/graphql/ExtractionTypes.graphql"
query AvailableInvoiceDocumentTypes(
  $transactionTypeId: Int!
  $isDocumentUpload: Boolean
) {
  invoiceSigningAvailableDocumentTypes(
    transactionTypeId: $transactionTypeId
    isDocumentUpload: $isDocumentUpload
  ) {
    nodes {
      id
      documentType
      isAccountingDocument
      _isAppliableDocumentType
      ...ExtractionTypes
    }
  }
}
